import React, {Component} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import tDetailActions from 'Actions/taskManage/detail';
import fpListActions from 'Actions/taskManage/firstPage';
import {Select, DatePicker, Table} from 'antd';

import {ExTable} from 'icsoc-antd-ex';
// import moment from 'moment';

const {
  Filter,
  Filter: {NormalFilter},
} = ExTable;
const {RangePicker} = DatePicker;
const {Option} = Select;

const staticCoulumns = [
  {
    title: '日期',
    dataIndex: 'dayStr',
    key: 'dayStr',
    align: 'center',
  },
  {
    title: '任务量',
    dataIndex: 'totalNum',
    key: 'totalNum',
    align: 'center',
  },
  {
    title: '外呼量',
    dataIndex: 'calledNum',
    key: 'calledNum',
    align: 'center',
  },
  {
    title: '接通量',
    dataIndex: 'answerNum',
    key: 'answerNum',
    align: 'center',
  },
  {
    title: '接通率',
    dataIndex: 'answerRate',
    key: 'answerRate',
    align: 'center',
    render: text => `${text.toFixed(2)}%`,
  },
  {
    title: '有效会话数',
    dataIndex: 'usefulInteractNum',
    key: 'usefulInteractNum',
    align: 'center',
  },
  {
    title: '无效会话数',
    dataIndex: 'uselessInteractNum',
    key: 'uselessInteractNum',
    align: 'center',
  },
  {
    title: '总交互轮次',
    dataIndex: 'totalInteractNum',
    key: 'totalInteractNum',
    align: 'center',
  },
  {
    title: '有效会话平均交互轮次',
    dataIndex: 'avgUsefulNum',
    key: 'avgUsefulNum',
    align: 'center',
    render: text => text.toFixed(2),
  },
  {
    title: '外呼通话总时长(秒)',
    dataIndex: 'totalCallTime',
    key: 'totalCallTime',
    align: 'center',
  },
  {
    title: '外呼通话平均时长(秒)',
    dataIndex: 'avgCallTime',
    key: 'avgCallTime',
    align: 'center',
  },
];

class staticOverview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      staticList: [],
      columnsStatic: [],
      values: {},
    };
  }

  componentDidMount() {
    const {DetailActions} = this.props;
    DetailActions.getTaskNameOptions();
    this.getList();
  }

  // 统计列表
  getList = () => {
    const {actions} = this.props;
    const {
      values: {date = [], taskId = ''},
    } = this.state;
    const todayStart = `${new Date().toLocaleDateString()} 00:00:00`;
    const todayEnd = `${new Date().toLocaleDateString()} 23:59:59`;
    const params = {
      startTime: date.length
        ? Date.parse(date[0])
        : new Date(todayStart.replace(/-/g, '/')).getTime(),
      endTime: date.length
        ? Date.parse(date[1])
        : new Date(todayEnd.replace(/-/g, '/')).getTime(),
      taskId,
    };
    this.setState({loading: true});
    actions.getTaskFirstPageList(params).then(res => {
      const {data, code} = res.payload;
      if (code === 200) {
        this.setState({
          loading: false,
          staticList: data,
          columnsStatic: staticCoulumns,
        });
      } else {
        this.setState({
          loading: false,
          staticList: [],
          columnsStatic: staticCoulumns,
        });
      }
    });
  };

  // 搜索
  handleFilter = fields => {
    this.setState({values: fields}, () => {
      this.getList();
    });
  };

  handleVisibleChange = () => {
    const {visible} = this.state;
    this.setState({visible: !visible});
  };

  render() {
    const {taskNameOptions} = this.props;
    const {loading, staticList, columnsStatic} = this.state;

    return (
      <div className="staticOverview">
        <div className="title">统计概况</div>
        <Filter handleFilter={this.handleFilter}>
          <NormalFilter>
            <NormalFilter.Item label="时间范围" initialValue={[]} field="date">
              <RangePicker />
            </NormalFilter.Item>
            <NormalFilter.Item label="任务名称" field="taskId">
              <Select
                showSearch
                allowClear
                placeholder="请输入内容"
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }>
                {Array.isArray(taskNameOptions)
                  ? taskNameOptions.map(({taskId, taskName}) => (
                      <Option value={taskId} key={taskId}>
                        {taskName}
                      </Option>
                    ))
                  : null}
              </Select>
            </NormalFilter.Item>
          </NormalFilter>
        </Filter>
        <Table
          scroll={{y: 200}}
          extraHeight={50}
          dataSource={staticList}
          columns={columnsStatic}
          loading={loading}
          rowKey="id"
          onChange={this.handleTableChange}
          pagination={false}
        />
      </div>
    );
  }
}

const mapStateToProps = ({taskManageDetail}) => ({
  taskNameOptions: taskManageDetail.taskNameOptions,
});

const mapDispatchToProps = dispatch => {
  return {
    DetailActions: bindActionCreators(tDetailActions, dispatch),
    actions: bindActionCreators(fpListActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(staticOverview);
